/**
 * Name: Update playlist
 * Author: @Gaurav
 * Date: 21-07-2021
 */
import { put, takeLatest, call } from 'redux-saga/effects';
import ApiCaller from '../ApiCaller';

const callAPI = (payload) => {
  return ApiCaller('/v1/admin/playlist', 'PATCH', payload);
};

export default function* watchRequest() {
  yield takeLatest('UPDATE_PLAYLIST', function* performAction(action) {
    yield put({ type: 'UPDATE_PLAYLIST_INITIATED' });
    try {
      const data = yield call(callAPI.bind(this, action.payload));
      yield put({ type: 'UPDATE_PLAYLIST_SUCCESS', payload: data });
    } catch (error) {
      yield put({ type: 'UPDATE_PLAYLIST_FAILED', payload: error });
    }
  });
}

